// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__mz-ko","left":"StickyBox_left__3wBYC","right":"StickyBox_right__1CYaz"};